import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ParticipanteConglomerado } from "./participante.conglomerado.model";

export class Conglomerado extends BaseEntity{
    public id: number;
    public codigo: string;
    public modalidade: string;
    public dataRegistro: Date;
    public nomeUsuarioADResponsavel: string;
    public participanteConglomerado: ParticipanteConglomerado[];
    public percentualAutomatico: boolean;
}

